var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDocumentInternational(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 24c-3.584 0-6.5-2.916-6.5-6.5s2.916-6.5 6.5-6.5 6.5 2.916 6.5 6.5-2.916 6.5-6.5 6.5zm0-12c-3.033 0-5.5 2.468-5.5 5.5s2.467 5.5 5.5 5.5 5.5-2.468 5.5-5.5-2.467-5.5-5.5-5.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 23.65a.5.5 0 01-.5-.5v-11.3a.5.5 0 011 0v11.3a.5.5 0 01-.5.5zM19.5 23.65a.5.5 0 01-.5-.5v-11.3a.5.5 0 011 0v11.3a.5.5 0 01-.5.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.15 16h-11.3a.5.5 0 010-1h11.3a.5.5 0 010 1zM23.15 20h-11.3a.5.5 0 010-1h11.3a.5.5 0 010 1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 20h-7c-.827 0-1.5-.673-1.5-1.5v-11a.5.5 0 01.5-.5h17a.5.5 0 01.5.5v2.06a.5.5 0 01-1 0V8H2v10.5a.5.5 0 00.5.5h7a.5.5 0 010 1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 11h-5a.5.5 0 010-1h5a.5.5 0 010 1zM19.5 8H.5a.5.5 0 01-.5-.5v-4A.5.5 0 01.5 3h19a.5.5 0 01.5.5v4a.5.5 0 01-.5.5zM1 7h18V4H1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 4a.502.502 0 01-.354-.146L16.293 1H3.707L.854 3.854a.5.5 0 01-.707-.707l3-3A.496.496 0 013.5 0h13c.133 0 .26.053.354.146l3 3A.5.5 0 0119.5 4z"
  })));
}

export default SvgDocumentInternational;